import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-no-csp-support-info',
  imports: [MatIconModule, TranslateModule],
  templateUrl: './no-csp-support-info.component.html',
  styleUrl: './no-csp-support-info.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class NoCspSupportInfoComponent {
  @Input() script?: boolean;

  constructor(private translate: TranslateService) {}

  get complianceText(): string {
    const key = this.script
      ? 'campaign.widget.sidebar.layout.script-not-compliant'
      : 'campaign.widget.sidebar.layout.component-not-compliant';
    const translated = this.translate.instant(key);
    return translated.replace(/CSP/g, '<abbr title="Content Security Policy">CSP</abbr>');
  }
}
